// src/Student-Dashboard-Component/Comman/handleStudentLogout.js
import Swal from 'sweetalert2';
import API_URL from '../../../config';

const handleStudentLogout = async (navigateCallback) => {
  // Confirm logout first
  const result = await Swal.fire({
    title: 'Are you sure you want to logout?',
    text: "You will be redirected to the login page.",
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Yes, logout!',
  });

  if (!result.isConfirmed) return;

  const token = localStorage.getItem('studentToken');

  try {
    if (token && token !== '') {
      // Call API logout endpoint only if token exists
      const response = await fetch(`${API_URL}/api/logout`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        const data = await response.json().catch(() => ({}));
        throw new Error(data.message || 'Logout failed');
      }
    }

    // Remove student token & data
    localStorage.removeItem('studentToken');
    localStorage.removeItem('studentData');

    Swal.fire({
      title: 'Logged Out!',
      text: 'You have been successfully logged out.',
      icon: 'success',
      timer: 2000,
      showConfirmButton: false,
    });

    // Redirect after short delay
    setTimeout(() => {
      if (typeof navigateCallback === 'function') navigateCallback();
    }, 2000);

  } catch (error) {
    console.error('Student logout error:', error);
    Swal.fire('Error', `Logout failed: ${error.message}`, 'error');
  }
};

export default handleStudentLogout;
